<template>
	<div >
		<!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button>
    </el-radio-group> -->
		<el-menu default-active="1-4-1" unique-opened class="el-menu-vertical-demo" 
			:collapse="isCollapse" :background-color="menucolor" :text-color="textcolor" active-text-color="#ffd04b">
			<h3 >{{isCollapse ? '后台':' 触圈财务后台' }}</h3>
			<el-menu-item v-for="item in noChildren" :key="item.name" :index="item.name" @click="gomenu(item)">
				<i :class="item.icon"></i>
				<span slot="title">{{item.label}}</span>
			</el-menu-item>
			<el-submenu :index="item.label" v-for="item in haveChildren" :key="item.label">
				<template slot="title">
					<i :class="item.icon"></i>
					<span slot="title">{{item.label}}</span>
				</template>
				<el-menu-item-group v-for="it in item.children" :key="it.name">
					
					<el-menu-item :index="it.name" @click="gomenu(it)"><i :class="it.icon"></i>{{it.label}}</el-menu-item>
				</el-menu-item-group>
			</el-submenu>


		</el-menu>
	</div>
</template>

<script>
	import Cookie from 'js-cookie'
	export default {
		data() {
			return {
				
				
			};
		},
		methods: {
			gomenu(item){
				if(this.$route.path !== item.path ){
					this.$router.push(item.path)
				}
				this.$store.commit('selectMunu',item)
			},
			
		},
		mounted() {
			//console.log(this.menuData);
		},
		computed: {
		 //没有子菜单
			noChildren() {
				return this.menuData.filter(item => !item.children)
			},
			//有子菜单
			haveChildren() {
				return this.menuData.filter(item => item.children)
			},
			isCollapse(){
				return this.$store.state.tab.isCollapse
			},
			menucolor(){
				return this.$store.state.tab.menucolor
			},
			textcolor(){
				return this.$store.state.tab.textcolor
			},
			//菜单
			menuData(){
				return  JSON.parse(Cookie.get('menu')) || this.$store.state.tab.menu
			}
		}
	}
</script>
<style lang="less" scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}
	.el-menu{
		border-right: none;
		height: 100vh;
		h3{
			text-align: center;
			line-height: 48px;
			color: aliceblue;
			font-size: 16px;
			font-weight: 400;
		}
	}
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
